import { Translation } from "@/data/lang";

import { ToggleButtonOption } from "ui/widget/toggle-buttons";

export const getTop20CostEstimationOptions = ({
  t,
}: {
  t: Translation;
}): ToggleButtonOption[] => [
  { value: t.my13F.investor.lineChart },
  { value: t.my13F.investor.table },
];
